import VALUES from 'core/data-model/constants/values'
import {
  getForeignExchangeRiskQuestion,
  isSelectedYesOnForeignExchangeRiskQuestion,
} from 'core/service/investment/questionnaire'
import {
  calculateAcceptableRiskRange,
  calculateOverRiskRange,
  calculateRiskLevel,
} from 'core/service/investment/risklevel'
import _ from 'lodash'
import { createSelector } from 'reselect'

export const getAgentComment = (state) => state.investment.investmentRisk.agentComment
export const getAllowHigherRiskInvestment = (state) => {
  return state.investment.investmentRisk.allowHigherRiskInvestment
}
export const getAllowForeignInvestment = (state) => {
  return state.investment.investmentRisk.allowForeignInvestment
}
export const getQuestionnaire = (state) => state.investment.investmentRisk.questionnaires
export const getTotalQuestionnaire = (state) => state.investment.investmentRisk.questionnaires.length
export const isEvaluated = (state) => state.investment.investmentRisk.riskEvaluated.isEvaluated
export const getInvestmentRisk = (state) => state.investment.investmentRisk
export const getRiskLevel = (state) => state.investment.investmentRisk.riskLevel.level
export const getRiskEvaluated = (state) => state.investment.investmentRisk.riskEvaluated

export const hasValidEntryComponent = (state) => {
  return state.entryComponent.source === 'perfect-advice'
}

export const isLowRiskEvaluated = (state) => {
  return state.investment.investmentRisk.riskEvaluated.value <= VALUES.HIGH_RISK
}

export const totalAnswered = (questionnaires) => {
  const selectedChoices = _.filter(questionnaires, (q) => q.selectedChoice != 0)
  return selectedChoices.length
}

export const isOnlyBankDeposit = (questionnaires) => {
  const multipleChoiceQuestion = _.find(questionnaires, (q) => q.multipleChoice)
  const sumMultipleChoiceQuestion = multipleChoiceQuestion.selectedChoice.reduce((prev, item) => prev + item, 0)
  return multipleChoiceQuestion.selectedChoice.includes(1) && sumMultipleChoiceQuestion === 1
}

export const _answeredPercent = (questionnaires) => (totalAnswered(questionnaires) / questionnaires.length) * 100
export const answeredPercent = createSelector(getQuestionnaire, _answeredPercent)

export const _answeredCount = (questionnaires) => totalAnswered(questionnaires)
export const answeredCount = createSelector(getQuestionnaire, _answeredCount)
export const _getRiskLevelResult = (questionnaire, riskLevel) =>
  calculateRiskLevel(totalScore(questionnaire), riskLevel)

export const getRiskLevelResult = createSelector(getQuestionnaire, getRiskLevel, _getRiskLevelResult)
export const getAcceptableRiskRange = createSelector(getRiskLevelResult, getRiskLevel, calculateAcceptableRiskRange)
export const getOverRiskRange = createSelector(getRiskLevelResult, getRiskLevel, calculateOverRiskRange)
export const totalScore = (questionnaires) => {
  let score = 0
  _.forEach(questionnaires, (item) => {
    if (item.hasScore) {
      if (Array.isArray(item.selectedChoice) && item.selectedChoice.length !== 0) {
        score += _.max(item.selectedChoice)
      } else {
        score += +item.selectedChoice
      }
    }
  })
  return score
}

export const getRPQScore = createSelector(getQuestionnaire, totalScore)

export const hasFinishedRiskEvaluation = createSelector(
  getRiskEvaluated,
  (riskEvaluated) => riskEvaluated.isEvaluated === true
)

export const hasFinishedFundAllocation = (state) => _.get(state, 'investment.funds.totalAllocation.value') === 100

export const getExchangeQuestion = createSelector(getQuestionnaire, getForeignExchangeRiskQuestion)

export const isSelectedYesOnForeignExchangeQuestion = createSelector(
  getQuestionnaire,
  isSelectedYesOnForeignExchangeRiskQuestion
)
